var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('error-dialog', {
    attrs: {
      "status": _vm.saveStatus
    }
  }), _c('sign-in-dialog', {
    ref: "sign-in",
    model: {
      value: _vm.showSignInDialog,
      callback: function ($$v) {
        _vm.showSignInDialog = $$v;
      },
      expression: "showSignInDialog"
    }
  }, [_c('template', {
    slot: "subtitle"
  }, [_vm._v(" Sign in to accept our "), _c('a', {
    attrs: {
      "href": "/terms-and-conditions"
    }
  }, [_vm._v("terms and conditions")]), _vm._v(" and link this card with your account ")])], 2), _c('v-container', [_c('h1', {
    staticClass: "mt-6 text-h4 text-sm-h3 header-font"
  }, [_vm._v("Create a reusable group card design")]), _c('div', {
    staticClass: "mt-3 mb-12"
  }, [_vm._v("Add a cover image or short animated video / GIF, and we'll store the design in your account. You can also share it with others so that they can send cards using your cover design.")]), _c('card-file-input', {
    staticClass: "mx-auto",
    staticStyle: {
      "max-width": "min(50%, 360px)"
    },
    on: {
      "input": function (x) {
        return _vm.toSave = x;
      }
    }
  }), _c('div', {
    staticClass: "text-center py-6"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.toSave,
      "loading": _vm.saveStatus.pending
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])], 1), _c('h2', {
    staticClass: "pt-6 text-h5"
  }, [_vm._v("Tips")]), _c('ul', [_c('li', [_vm._v("You can use any image or video file format that your browser can read, like JPEG, PNG, GIF, or MP4.")]), _c('li', [_vm._v("Maximum file size is limited to 10 MB.")]), _c('li', [_vm._v("Images / videos will be automatically cropped to fill our 5x7 cards. For the best quality possible, use a resolution of at least 600x840.")]), _c('li', [_vm._v("Your files will be automatically compressed / transcoded – please double-check the final version from your Ellacard account")])]), _c('h2', {
    staticClass: "text-h5 pt-6"
  }, [_vm._v("Monetizing your designs")]), _c('p', [_vm._v("Want to sell your designs on Ellacard? Check out our "), _c('router-link', {
    attrs: {
      "to": {
        name: 'design'
      }
    }
  }, [_vm._v("design portal")]), _vm._v(" to get started.")], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }